export enum ReportingFrequency {
    Monthly = 1,
    Quarterly = 2,
    Biannually = 3,
    Annually = 4,
    Daily = 5,
    Weekly = 6,
    Fortnightly = 7,
    MonthlyWeekday = 8
}